import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import About from "./components/About";
import Vision from "./components/Vision";
import FeaturedProject from "./components/FeaturedProject";
import Investment from "./components/Investment";
import Experience from "./components/Experience";
import FinalCta from "./components/FinalCta";

export default function Home() {
  return (
    <Layout>
      <Hero />
      <About />
      <Vision />
      <FeaturedProject />
      <Investment />
      <Experience />
      <FinalCta />
    </Layout>
  );
}